import styled from "styled-components";

export const TabContainer = styled.div`
  display: flex;
  width: 100%;
  //   background: red;
  padding: 1rem 1rem 0px 1rem;
  border-top: 2px solid #edeff2;
  border-bottom: 2px solid #edeff2;
  align-items: stretch;
`;

const selectedColor = "#2A3DA3";
const defaultColor = "transparent";

export const TabItem = styled.div`
  background-color: white;
  font-family: "Poppins";
  font-size: 12px;
  font-weight: 600;
  width: 100%;
  padding: 10px;
  cursor: pointer;
  transition: 0.3s;
  text-align: center;
  color: ${(props) => (props.selected ? selectedColor : "#ADB8CC")};
  border-bottom: 4px solid
    ${(props) => (props.selected ? selectedColor : defaultColor)};
`;
